<div class="">
  <div class="col-xs-5 nopadding-left">
    <div clss="form-elem">
      <div class="form-elem-name">Year</div>
      <div class="form-elem-field">
        <select [(ngModel)]="year" [formControl]="dobForm.controls['year']" (change)="isInputTouchedAndValid()">
          <option></option>
          <option *ngFor="let item of yearList" [ngValue]="item">{{item}}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="col-xs-4">
    <div clss="form-elem">
      <div class="form-elem-name">Month</div>
      <div class="form-elem-field">
        <select [(ngModel)]="month" [formControl]="dobForm.controls['month']" (change)="isInputTouchedAndValid()">
          <option></option>
          <option value="01">January</option>
          <option value="02">February</option>
          <option value="03">March</option>
          <option value="04">April</option>
          <option value="05">May</option>
          <option value="06">June</option>
          <option value="07">July</option>
          <option value="08">August</option>
          <option value="09">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>
      </div>
    </div>
  </div>

  <div class="col-xs-3 nopadding-right">
    <div clss="form-elem">
      <div class="form-elem-name">Day</div>
      <div class="form-elem-field">
        <select [(ngModel)]="day" [formControl]="dobForm.controls['day']" (change)="isInputTouchedAndValid()">
          <option></option>
          <option *ngFor="let item of daysInMonth" [ngValue]="item">{{item}}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="clear"></div>

  <div *ngIf="isInputTouchedAndValid() != null && isInputTouchedAndValid() == false" class="mb-error-fail-wrap">
    <div class="mb-error-fail">You must be at least 18 years old</div>
  </div>
</div>
